import { render, staticRenderFns } from "./matchSection.vue?vue&type=template&id=096b2b79&"
import script from "./matchSection.vue?vue&type=script&lang=js&"
export * from "./matchSection.vue?vue&type=script&lang=js&"
import style0 from "./style.module.scss?vue&type=style&index=0&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports